<template>
  <section class="gradient-map">
    <svg xmlns="http://www.w3.org/2000/svg" class="svg-filters">
      <filter id="elbo-gradientmap">
        <feColorMatrix type="matrix" result="grayscale"
                       values="1 0 0 0 0
                               1 0 0 0 0
                               1 0 0 0 0
                               0 0 0 1 0" >
        </feColorMatrix>
        <feComponentTransfer color-interpolation-filters="sRGB" result="duotone">
          <!-- <feFuncR type="table" tableValues="0.901960784313725 0.337254901960784"></feFuncR>
          <feFuncG type="table" tableValues="0.098039215686275 0.325490196078431"></feFuncG>
          <feFuncB type="table" tableValues="0.098039215686275 0.325490196078431"></feFuncB> -->
          <feFuncR type="table" tableValues="0 0.901960784313725"></feFuncR>
          <feFuncG type="table" tableValues="0 0.098039215686275"></feFuncG>
          <feFuncB type="table" tableValues="0 0.098039215686275"></feFuncB>
          <feFuncA type="table" tableValues="0 1"></feFuncA>
        </feComponentTransfer>
      </filter>
    </svg>
  </section>
</template>

<script>
export default {
  name: 'GradientMap'
}
</script>
